/**
 * Set new item values in the array by serviceId
 * */
export const setItemValueById = (id, { list, value }) => (id ? list.map((i) => (
  i.serviceId === id ? { ...i, ...value } : i)) : list);

/**
 * Set new item values in the array by serviceType
 * */
export const setItemValueByType = (type, { list, value }) => (type ? list.map((i) => (
  i.serviceType === type ? { ...i, ...value } : i)) : list);
